import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SupportContactTypeEnum } from 'src/app/shared/enum/admin-user/support-contact-type.enum';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { MultiFactorAuthenticationService } from 'src/app/shared/services/API/user/multi-factor-authentication.service';
import { MultiFactorAuthenticationRequest } from 'src/app/shared/services/requests/user/multi-factor-authentication.request';
import { UserLoginResponse } from 'src/app/shared/services/responses/user/auth.response';
import { UtilService } from 'src/app/shared/services/util.service';
import { SendMultiFactorAuthenticationService } from 'src/app/shared/services/API/orchestrator-user/send-multi-factor-authentication.service';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

@Component({
    selector: 'app-multi-factor-authentication',
    templateUrl: './multi-factor-authentication.component.html',
    styleUrls: ['./multi-factor-authentication.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MultiFactorAuthenticationComponent implements OnInit {

  constructor(private alertService: AlertService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private utilsService: UtilService,
    private multiFactorAuthenticationService: MultiFactorAuthenticationService,
    private sendMultiFactorAuthenticationService: SendMultiFactorAuthenticationService,
  ) { }

  public supportContactTypeEnum: typeof SupportContactTypeEnum = SupportContactTypeEnum;

  public model: FormGroup;
  public tokenHealthUnit: UserLoginResponse;

  public isLoading: boolean;
  public shippingMethodAlreadyChosen: boolean = false;
  public canResend: boolean = false;

  public chosenShippingMethod: number;
  public remainingTime: number = 60;

  public email: string;
  public phone: string;
  public idBrowserVisitor: string;
  public token: string;
  public biRedirect: string;

  public interval: ReturnType<typeof setInterval>;

  ngOnInit(): void {

    this.getDeviceId();

    this.tokenHealthUnit = this.utilsService.getToken();
    if(this.tokenHealthUnit.email)
      this.email = this.tokenHealthUnit.email;
    if(this.tokenHealthUnit.phone)
      this.phone = this.tokenHealthUnit.phone;

    this.biRedirect = this.activatedRoute.snapshot.paramMap.get('biRedirect');
    if(this.biRedirect == 'null' || this.biRedirect == 'undefined')
      this.biRedirect = null;
  }

  startCountdown() {
    this.canResend = false;

    this.interval = setInterval(() => {
      this.remainingTime--;

      if (this.remainingTime <= 0) {
        clearInterval(this.interval);
        this.canResend = true;
        this.remainingTime = 60; // reinicia para próxima vez
      }
    }, 1000);
  }

  finishCountDown() {
    clearInterval(this.interval);
    this.remainingTime = 60;
  }

  checkMultiFactorAuthenticationCode() {
    
    if(!this.token || this.token.length != 4) {
      this.alertService.show("Erro", 'Insira o código de verificação', AlertType.error);
      return;
    }

    this.isLoading = true;
    
    let request = new MultiFactorAuthenticationRequest();

    request.token = parseInt(this.token);
    request.chosenShippingMethod = this.chosenShippingMethod;
    request.idBrowserVisitor = this.idBrowserVisitor;

    this.multiFactorAuthenticationService.checkToken(request).subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show("Erro inesperado", response.errorDescription, AlertType.error);
          this.isLoading = false;
          return;
        }

        this.finishCountDown();

        if (this.tokenHealthUnit.idDefaultModule && this.tokenHealthUnit.uriDefaultModule) {
          this.router.navigate([this.tokenHealthUnit.uriDefaultModule])
        }
        else if (this.biRedirect) {
          this.router.navigate(['/bi/details', { idReportFunctionHealthUnit: this.biRedirect }])
        }
        else
          this.router.navigate(['/welcome'])
      },
      error: (error) => {
        this.alertService.show("Erro inesperado", error, AlertType.error);
        this.isLoading = false;
      }
    });
  }

  sendMultiFactorAuthenticationCode() {

    if(!this.chosenShippingMethod) {
      this.alertService.show("Erro", 'Selecione uma das opções', AlertType.error);
      return;
    }

    this.isLoading = true;
    
    this.startCountdown();

    let request = new MultiFactorAuthenticationRequest();

    request.chosenShippingMethod = this.chosenShippingMethod;
    request.idBrowserVisitor = this.idBrowserVisitor;

    this.sendMultiFactorAuthenticationService.sendToken(request).subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show("Erro inesperado", response.errorDescription, AlertType.error);
          this.isLoading = false;
          return;
        }

        this.shippingMethodAlreadyChosen = true;
        this.isLoading = false;
      },
      error: (error) => {
        this.alertService.show("Erro inesperado", error, AlertType.error);
        this.isLoading = false;
      }
    });
  }

  goBackLogin() {
    this.router.navigate(['/auth'])
  }

  optChange(value: string) {
    this.token = value;
  }

  async getDeviceId() {
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    this.idBrowserVisitor = result.visitorId;
  }

}
